import clsx from 'clsx';
import { categoriaDe } from '../publicacao.definitions';
import type { TipoPublicacao } from '../publicacao.types';

interface PublicacaoCapaProps {
  titulo: string;
  categoria: string;
  tipo?: TipoPublicacao;
  capaUrl: string | null;
  /** Feed = card; pagina = topo do post aberto. */
  tamanho?: 'card' | 'pagina';
}

/** Imagem enviada ou, sem imagem, a cor da categoria com o título. */
export function PublicacaoCapa({ titulo, categoria, tipo = 'post', capaUrl, tamanho = 'card' }: PublicacaoCapaProps) {
  const proporcao = tamanho === 'card' ? 'aspect-[16/7]' : 'aspect-[16/6]';
  if (capaUrl) {
    return <img src={capaUrl} alt="" className={clsx('w-full object-cover', proporcao)} />;
  }
  return (
    <div
      className={clsx(
        'grid place-items-center bg-gradient-to-br px-6 text-center font-montserrat font-bold text-white',
        categoriaDe({ tipo, categoria: categoria as never }).capa,
        proporcao,
        tamanho === 'card' ? 'text-base' : 'text-xl sm:text-2xl'
      )}
    >
      {titulo}
    </div>
  );
}
